import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

type SceneDesignSelectionState = {
    selectedIds: Record<string, boolean>;
};

const initialState: SceneDesignSelectionState = {
    selectedIds: {},
};

const sceneDesignSelectionSlice = createSlice({
    name: 'sceneDesignSelection',
    initialState,
    reducers: {
        toggleSceneDesignSelection(state, action: PayloadAction<{ sceneDesignId: string }>) {
            const { sceneDesignId } = action.payload;
            if (state.selectedIds[sceneDesignId]) {
                delete state.selectedIds[sceneDesignId];
            } else {
                state.selectedIds[sceneDesignId] = true;
            }
        },
        deselectAllSceneDesigns(state) {
            state.selectedIds = {};
        },
        setSelectedSceneDesigns(state, action: PayloadAction<{ sceneDesignIds: string[] }>) {
            state.selectedIds = {};
            action.payload.sceneDesignIds.forEach((id) => {
                state.selectedIds[id] = true;
            });
        },
    },
});

export const { toggleSceneDesignSelection, deselectAllSceneDesigns, setSelectedSceneDesigns } =
    sceneDesignSelectionSlice.actions;

export default sceneDesignSelectionSlice;
